import React, {Component} from 'react';
import classnames from 'classnames';
import {connect} from "react-redux";
import {Grid, Row, Col, Image} from 'react-bootstrap';
import './instruction.css';
import { FaCheckCircle } from "react-icons/fa";
import {setImage} from '../../redux/actionCreators';
import FooterContainer from '../../components/footer/FooterContainer';
import MainButton from '../../components/buttons/main_button/MainButton';
import CircularProgressBarStep from '../../components/circular_progress_bar_step/CircularProgressBarStep';

//TODO merge instruction with camera component.
class Instruction extends Component {

    componentDidMount() {
        this.props.setImage(undefined);
    }

    render() {
        let icon;
        let epigraph = this.props.stepInfo.epigraph;
        if (this.props.stepInfo.icon) {
            icon = require(`../../resources/images/${this.props.stepInfo.icon}`).default;
        }
        if (this.props.stepInfo.epigraph !== '') {
            epigraph = <h2>{epigraph}</h2>
        }
        let buttonText = this.props.buttonText;
        if (this.props.stepInfo.buttonText && this.props.stepInfo.buttonText !== '') {
            buttonText = this.props.stepInfo.buttonText;
        }
        return (
            <div className={classnames('instruction',{[this.props.stepInfo.additionalClass]: this.props.stepInfo.additionalClass && this.props.stepInfo.additionalClass !== '',})}
            >
                <Grid>
                    <div className={'content'}>
                        {this.props.stepInfo.alertText && this.props.stepInfo.alertText !== '' &&
                            <div className={'alert'}>
                                <FaCheckCircle className='icon-success-step' color='#00875A' fontSize='18px' /> {this.props.stepInfo.alertText}
                            </div>
                        }
                        <div className={'break-top'}></div>
                        <Row>
                            <Col xs={12}>
                                <div className={'number'}>
                                    <CircularProgressBarStep />
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                {epigraph}
                                <h1 className={'title'}>{this.props.stepInfo.title}</h1>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <div className="image">
                                    <Image src={icon}/>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <p className={'description'} dangerouslySetInnerHTML={{ __html: this.props.stepInfo.description }} />
                            </Col>
                            {this.props.stepInfo.additionalDescription &&  this.props.stepInfo.additionalDescription !== '' &&
                                <Col xs={12}>
                                    <p className={'description'} dangerouslySetInnerHTML={{ __html: this.props.stepInfo.additionalDescription }} />
                                </Col>
                            }
                            {this.props.stepInfo.additional &&  this.props.stepInfo.additional !== '' &&
                                <Col xs={12}>
                                    <div className={'alert-box'}>
                                        <span className={'warning-icon'}>!</span> 
                                        <p className={'additional'}>
                                            {this.props.stepInfo.additional}
                                        </p>
                                    </div>
                                </Col>
                            }
                        </Row>
                        <FooterContainer>
                            <MainButton 
                                onClick={this.props.nextStep}
                                text={buttonText}
                            />
                        </FooterContainer>
                    </div>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        stepInfo: state.stepInfo,
        image: state.image,
        background: state.background,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setImage(image) {
            dispatch(setImage(image));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Instruction);
